import { Popover } from '@mui/material'
import { theme, themeUtils } from 'styles/theme'

export const InformationPopover = ({
  anchorEl,
  handlePopoverClose,
  label
}: {
  anchorEl: HTMLElement | null
  handlePopoverClose: () => void
  label: string
}) => {
  const isPopoverOpen = Boolean(anchorEl)
  return (
    <Popover
      id="mouse-over-popover"
      sx={{
        pointerEvents: 'none',
        '& .MuiPaper-root': {
          boxShadow: '0px 3px 4px rgba(0,0,0,0.13)'
        }
      }}
      open={isPopoverOpen}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 24, // 24px below top-left corner of anchor
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <div
        style={{
          padding: '5px 9px',
          color: theme.palette.label.subdued,
          textOverflow: 'wrap',
          maxWidth: '212px',
          width: 'fit-content',
          borderRadius: '4px',
          border: '2px solid #E2E2E2'
        }}
        css={themeUtils.bodyXSmall}
      >
        {label}
      </div>
    </Popover>
  )
}
